import React, { useState, useRef, useEffect } from "react";
import api from "../../services/api";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useCustomScreen, useScreenSize } from "../Utils";

export default function HeroSection() {
  const [address, setAddress] = useState("");
  const autocompleteRef = useRef(null);
  const [autoComplete, setAutoComplete] = useState(null);
  const mapsApikey = "AIzaSyCeN735tEju-8a1lqgQZ19foswQKNmOp64";
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [countArr, setCountArr] = useState([0]);
  const [place, setPlace] = useState(null);
  const libraries = ["places"];
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  const [fontSize, setFontSize] = useState(getFontSize(window.innerWidth));
  const devicePixelRatio = window.devicePixelRatio;

  function getFontSize(width) {
    if (width > 2000) return "5rem"; // 4K Screens
    if (width > 1400 && width <= 2000) return "4rem"; // XXL Screens
    if (width > 1200 && width <= 1400) return "3.5rem"; // XL Screens
    if (width >= 1024 && width <= 1200) return "3rem"; // Large Screens
    if (width > 768 && width <= 1023) return "2rem"; // Medium Screens
    if (width > 576 && width <= 768) return "2rem"; // Small Screens
    return "1.92rem"; // Extra Small Screens (below 576px)
  }

  const handlePlaceSearch = (e) => {
    e.preventDefault();
    if (!place || place === undefined || place === null) return;
    try {
      // localStorage.setItem("selectedAddress", address);
      // Cookies.set("selectedAddress", address, { expires: 7, secure: true });
      localStorage.setItem("selectedAddress", JSON.stringify(place));
      Cookies.set("selectedAddress", JSON.stringify(place), {
        expires: 7,
        secure: true,
      });
      navigate("/order-page", { state: { place } });
    } catch (err) {}
  };
  const onPlaceChanged = () => {
    if (autoComplete !== null) {
      const place = autoComplete.getPlace();
      if (
        place &&
        place.geometry &&
        place.geometry.location &&
        place.address_components
      ) {
        try {
          const getComponent = (type) =>
            place.address_components.find((comp) => comp.types.includes(type))
              ?.long_name || "";

          const streetNumber = getComponent("street_number");
          const route = getComponent("route");
          const city =
            getComponent("locality") ||
            getComponent("sublocality") ||
            getComponent("administrative_area_level_2");
          const state = getComponent("administrative_area_level_1");
          const country = getComponent("country");
          const postalCode = getComponent("postal_code");

          const fullStreetAddress = `${streetNumber} ${route}`.trim();

          setPlace({
            address: place?.formatted_address,
            street: fullStreetAddress,
            city,
            state,
            country,
            postalCode,
            lat: place?.geometry?.location?.lat(),
            lng: place?.geometry.location.lng(),
          });
          setAddress(place.formatted_address);
        } catch (err) {
          console.log("Error setting place or address", err);
        }
      } else {
        console.log("Place or its geometry/location is undefined");
      }
    } else {
      console.log("autocomplete is null");
    }
  };

  const onLoad = (autoCompleteInstance) => {
    setAutoComplete(autoCompleteInstance);
  };

  useEffect(() => {
    loadCount();
  }, [count]);

  const loadCount = async () => {
    let result;
    try {
      result = await api({
        method: "GET",
        url: `/orders/get-all-orders-count`,
      });
      setCount(result + 100000);
      setCountArr(Array.from(String(count), Number));
    } catch (e) {
      console.log(e);
    }
  };
  const fourKScreenStyle = {
    width: "100%",
    height: is4kScreen ? "50vh" : "",
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    paddingLeft: "4rem",
    alignItems: "center",
    marginTop: "5rem",
  };

  const largeScreenStyle = {
    width: "100%",
    height: isLargeScreen ? "50vh" : "",
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    marginTop: "16rem",
    paddingLeft: "2rem",
  };

  const XLargeScreenStyle = {
    width: "100%",
    height: isLargeScreen ? "50vh" : "",
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    marginTop: devicePixelRatio === 1.5 ? "-2rem" : "",
    paddingLeft: "2rem",
  };

  const XXLargeScreenStyle = {
    width: "100%",
    height: isLargeScreen ? "50vh" : "",
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    marginTop: "2rem",
    paddingLeft: "2.5rem",
  };
  const loweContStyle = {
    height: is4kScreen ? "50vh" : "",
  };
  return (
    <section
      style={{ width: "100%" }}
      id="hero"
      className="d-flex align-items-center "
    >
      <div
        className="container  w-100 d-flex flex-column "
        style={{
          zIndex: "9",
          width: "100%",
          justifyContent: isXxlScreen
            ? "space-evenly"
            : isXlScreen
            ? "space-evenly"
            : isLargeScreen
            ? "center"
            : isSmallScreen
            ? "space-evenly "
            : isIpadProPortrait
            ? "space-between"
            : "space-between",
        }}
      >
        <div
          style={
            is4kScreen
              ? fourKScreenStyle
              : isXxlScreen
              ? XXLargeScreenStyle
              : isXlScreen
              ? XLargeScreenStyle
              : isLargeScreen
              ? largeScreenStyle
              : {}
          }
        >
          <div
            className="p-3"
            style={{
              height: "auto",
              marginTop: isIpadProPortrait ? "8rem" : "",
            }}
          >
            <h2
              style={{
                fontSize: isSmallScreen
                  ? "2rem"
                  : isMediumScreen
                  ? "3rem"
                  : isIpadProPortrait
                  ? "3rem"
                  : isLargeScreen
                  ? " 2.5rem"
                  : isXlScreen
                  ? "2.6rem"
                  : isXxlScreen
                  ? "3.5rem"
                  : is4kScreen
                  ? "5rem"
                  : "",
                paddingBottom: isSmallScreen
                  ? "0px"
                  : is4kScreen
                  ? "3.5rem"
                  : isXxlScreen
                  ? "1.6rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : isLargeScreen
                  ? "1rem"
                  : "30px",
                fontWeight: "normal",
              }}
            >
              FAST, ACCURATE
            </h2>
            <h1
              className="mt-xl-3"
              style={{
                fontSize: isSmallScreen
                  ? "1.63rem"
                  : isMediumScreen
                  ? "3rem"
                  : isIpadProPortrait
                  ? "4rem"
                  : isLargeScreen
                  ? "2.5rem"
                  : isXlScreen
                  ? "2.7rem"
                  : isXxlScreen
                  ? "3.5rem"
                  : is4kScreen
                  ? "5rem"
                  : "",
                fontWeight: "bold",
                paddingBottom: is4kScreen
                  ? ""
                  : isXxlScreen
                  ? ""
                  : isXlScreen
                  ? ""
                  : isLargeScreen
                  ? ""
                  : "0px",
              }}
            >
              {" "}
              ROOF MEASUREMENTS
            </h1>
            <div
              style={{
                marginTop: is4kScreen
                  ? "2rem"
                  : isXxlScreen
                  ? "0.5rem"
                  : isXlScreen
                  ? ""
                  : isLargeScreen
                  ? ""
                  : "0px",
              }}
            >
              {countArr.map((count, index) => (
                <a
                  className="btn-get-started scrollto mt-md-4 mt-xl-4"
                  key={`${count}-${index}`}
                  style={{
                    marginRight: is4kScreen
                      ? "1rem"
                      : isXxlScreen
                      ? "0.3rem"
                      : isXlScreen
                      ? "0.3rem"
                      : isLargeScreen
                      ? "0.3rem"
                      : isMediumScreen
                      ? "0.5rem"
                      : "",
                    fontSize: isSmallScreen
                      ? "1.3rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1.2rem"
                      : isXlScreen
                      ? "1.2rem"
                      : isXxlScreen
                      ? "1.2rem"
                      : isXxlScreen
                      ? ""
                      : is4kScreen
                      ? "2rem"
                      : "18px",

                    padding: is4kScreen
                      ? "1rem"
                      : isLargeScreen
                      ? "0.3rem"
                      : "",
                  }}
                >
                  {count.toString()}{" "}
                </a>
              ))}
              <a
                style={{
                  verticalAlign: "bottom",
                  marginLeft: isSmallScreen
                    ? "0.5rem"
                    : isLargeScreen
                    ? "5px"
                    : isXlScreen
                    ? "10px"
                    : isXxlScreen
                    ? ""
                    : is4kScreen
                    ? ""
                    : "",
                  fontSize: isSmallScreen
                    ? "1.3rem"
                    : isMediumScreen
                    ? "1.4rem"
                    : isIpadProPortrait
                    ? "1.7rem"
                    : isLargeScreen
                    ? "1.2rem"
                    : isXlScreen
                    ? "1.5rem"
                    : isXxlScreen
                    ? "1.3rem"
                    : is4kScreen
                    ? "2.3rem"
                    : "18px",
                  color: "#000",
                }}
              >
                and counting
              </a>
            </div>
          </div>
        </div>

        <div
          style={{
            height: is4kScreen ? "50vh" : isXlScreen ? "auto" : "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: isSmallScreen ? "5rem" : "",
            marginBottom: is4kScreen ? "2rem" : isLargeScreen ? "15rem" : "",
            marginTop:
              isLargeScreen && devicePixelRatio
                ? " 2rem"
                : isLargeScreen
                ? "5rem"
                : isXxlScreen && devicePixelRatio === 1.25
                ? ""
                : isXxlScreen && devicePixelRatio >= 1.5
                ? ""
                : isXxlScreen
                ? "13rem"
                : isXlScreen && devicePixelRatio === 1.5
                ? "-3rem"
                : isXlScreen
                ? "5rem"
                : is4kScreen
                ? "5rem"
                : "",
          }}
          className="pt-4 p-3"
        >
          <div
            className="d-flex flex-column justify-content-end w-100"
            style={{
              height: isLargeScreen ? "50vh" : isXlScreen ? "40dvh" : "auto",
              marginTop: is4kScreen
                ? "10rem"
                : isSmallScreen
                ? "2.5rem "
                : isXxlScreen
                ? "4rem"
                : isXlScreen && devicePixelRatio === 1.5
                ? "5.5rem"
                : isXlScreen
                ? ""
                : isIpadProPortrait
                ? "10rem"
                : "",
            }}
          >
            <div
              style={{
                paddingBottom: is4kScreen
                  ? "3rem"
                  : isXxlScreen
                  ? "2rem"
                  : isXlScreen && devicePixelRatio === 1.5
                  ? "1.7rem"
                  : isXlScreen
                  ? "1.7rem"
                  : "",
              }}
            >
              <header className="section-header mb-2">
                <h3
                  className="lets"
                  style={{
                    fontSize: isSmallScreen
                      ? "1.23rem"
                      : isMediumScreen
                      ? "1.8rem"
                      : isIpadProPortrait
                      ? "2rem"
                      : isLargeScreen
                      ? "1.5rem"
                      : isXlScreen
                      ? "1.6rem"
                      : isXxlScreen
                      ? "1.8rem"
                      : is4kScreen
                      ? "3.4rem"
                      : "1.2rem",
                  }}
                >
                  Let's get started
                </h3>
                <p
                  style={{
                    fontSize: isSmallScreen
                      ? "1.1rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1.1rem"
                      : isXlScreen
                      ? "1.2rem"
                      : isXxlScreen
                      ? "1.2rem"
                      : isXxlScreen
                      ? ""
                      : is4kScreen
                      ? "2.2rem"
                      : "1.2rem",
                  }}
                >
                  First time? Sign up and get your first report{" "}
                  <b>
                    <Link to="/signup">FREE</Link>
                  </b>
                </p>
              </header>
              <div
                className="row row-eq-height justify-content-center"
                style={{
                  marginBottom: is4kScreen
                    ? "2rem"
                    : isLargeScreen
                    ? "1rem"
                    : "",
                }}
              >
                <div className="col-lg-6 ">
                  <form
                    method="post"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault(); // Prevent Enter from submitting or doing anything
                      }
                    }}
                    onSubmit={(e) => e.preventDefault()}
                  >
                    <LoadScript
                      googleMapsApiKey={mapsApikey}
                      libraries={libraries}
                      onError={() =>
                        console.error("Google Maps script failed to load")
                      }
                    >
                      <Autocomplete
                        onLoad={onLoad}
                        onPlaceChanged={onPlaceChanged}
                        options={{
                          componentRestrictions: { country: ["us", "ca", "au"] }, // 👈 Restrict to US, Canada, and Australia
                        }}
                      >
                        <input
                          type="text"
                          placeholder="Enter Address"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                          style={{
                            width: "100%",
                            height: is4kScreen
                              ? "4.5rem"
                              : isXxlScreen
                              ? "3rem"
                              : isXlScreen
                              ? ""
                              : isIpadProPortrait
                              ? "3rem"
                              : isLargeScreen
                              ? "2rem"
                              : isMediumScreen
                              ? "2.5rem"
                              : isSmallScreen
                              ? ""
                              : "45px",
                            border: "0px",
                            fontSize: is4kScreen
                              ? "2rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : isIpadProPortrait
                              ? "1.9rem"
                              : "18px",
                          }}
                        />
                      </Autocomplete>
                      <input
                        type="submit"
                        value="Search"
                        onClick={handlePlaceSearch}
                        disabled={!address}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault(); // Prevent Enter from submitting or doing anything
                          }
                        }}
                        style={{
                          fontSize: is4kScreen
                            ? "2.4rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isMediumScreen
                            ? "1.4rem"
                            : "18px",
                        }}
                      />
                    </LoadScript>
                  </form>
                </div>
              </div>
            </div>

            <div
              className="row  counters aos-init  aos-animate justify-content-center text-center py-3"
              data-aos="fade-up"
              data-aos-delay="100"
              style={{
                paddingTop: isLargeScreen ? "5rem" : "2rem",
                marginBottom: isLargeScreen ? "1rem" : "",
              }}
            >
              <div className="col-sm-4 d-flex flex-column align-items-center">
                <p
                  style={{
                    fontSize: isSmallScreen
                      ? ""
                      : isMediumScreen
                      ? "1rem"
                      : isIpadProPortrait
                      ? "1.6rem"
                      : isLargeScreen
                      ? "1rem"
                      : isXlScreen
                      ? "1rem"
                      : isXxlScreen
                      ? "1rem"
                      : isXxlScreen
                      ? ""
                      : is4kScreen
                      ? "1.8rem"
                      : "",
                  }}
                >
                  Delivered in just
                </p>
                <span
                  style={{
                    fontSize: isSmallScreen
                      ? ""
                      : isMediumScreen
                      ? ""
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1.2rem"
                      : isXlScreen
                      ? "1.3rem"
                      : isXxlScreen
                      ? "1.4rem"
                      : isXxlScreen
                      ? ""
                      : is4kScreen
                      ? "2.2rem"
                      : "",
                  }}
                >
                  1 Business Day
                </span>
              </div>
              <div className="col-sm-4 d-flex flex-column align-items-center">
                <p
                  style={{
                    fontSize: isSmallScreen
                      ? ""
                      : isMediumScreen
                      ? "1rem"
                      : isIpadProPortrait
                      ? "1.6rem"
                      : isLargeScreen
                      ? "1rem"
                      : isXlScreen
                      ? "1rem"
                      : isXxlScreen
                      ? "1rem"
                      : isXxlScreen
                      ? ""
                      : is4kScreen
                      ? "1.8rem"
                      : "",
                  }}
                >
                  Available
                </p>
                <span
                  style={{
                    fontSize: isSmallScreen
                      ? ""
                      : isMediumScreen
                      ? ""
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1.2rem"
                      : isXlScreen
                      ? "1.3rem"
                      : isXxlScreen
                      ? "1.3rem"
                      : isXxlScreen
                      ? ""
                      : is4kScreen
                      ? "2.2rem"
                      : "",
                  }}
                >
                  Rush Delivery
                </span>
              </div>
              <div className="col-sm-4 d-flex flex-column align-items-center">
                <p
                  style={{
                    fontSize: isSmallScreen
                      ? ""
                      : isMediumScreen
                      ? "1rem"
                      : isIpadProPortrait
                      ? "1.6rem"
                      : isLargeScreen
                      ? "1rem"
                      : isXlScreen
                      ? "1rem"
                      : isXxlScreen
                      ? "1rem"
                      : isXxlScreen
                      ? ""
                      : is4kScreen
                      ? "1.8rem"
                      : "",
                  }}
                >
                  We also do
                </p>
                <span
                  style={{
                    fontSize: isSmallScreen
                      ? ""
                      : isMediumScreen
                      ? ""
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1.2rem"
                      : isXlScreen
                      ? "1.3rem"
                      : isXxlScreen
                      ? "1.3rem"
                      : isXxlScreen
                      ? ""
                      : is4kScreen
                      ? "2.2rem"
                      : "",
                  }}
                >
                  Blueprint Take-Offs
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
